/**
 *Created by jmmartinez on 13/8/18
 *
 * v.1.1  25/01/2019 Añadido icon, itemSelected y filterable
 * v.1.2  4/03/2019 Añadido className, placeholder y cambiado el alignText del button para que salga a la izquierda
 * v.1.3  5/03/2019 Añadido filterable correctamente.
 *                  Añadido itemSelected
 *                  No se renderiza si la lista de items es null o está vacía (si no da problemas el componente)
 *                  Añadido popoverClassName
 * v.1.4  7/03/2019 Comentado itemSelected en componentWillReceiveProps
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 08/10/2020 En el constructor, asignamos a fieldText, fieldLabel y fieldKey el valor de la prop.
 *                  En el render, precalculamos el fieldLabel, apra ver si  existe item[fieldLabel]
 *
 *
 * v.2.2 06/05/2022 Fusión Planifikator y Sidemur
 * v.2.3 18/07/2022 En RenderItem, cambiada la condición  if (item[fieldKey]) por  if (item[fieldKey] != undefined) para que pinte los items con value 0.
 **/

import React from 'react'
import PropTypes from 'prop-types';

import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import { MenuItem, Button } from "@blueprintjs/core";
import { Select} from "@blueprintjs/select";


class ComboBox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            className: props.className,
            id: props.id ? props.id : "select",
            fieldText: props.fieldText ? props.fieldText : "nombre",
            fieldLabel: props.fieldLabel ? props.fieldLabel : "codigoid",
            fieldKey: props.fieldKey ? props.fieldKey : "codigo",
            items: props.items,
            itemSelected: props.itemSelected,
            icon: props.icon,
            filterable: props.filterable,
            placeholder: props.placeholder,
            popoverClassName: props.popoverClassName,
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if( nextProps.items !== prevState.items){
            newState.items= nextProps.items;
        }

        if( nextProps.itemSelected !== prevState.itemSelected){
            newState.itemSelected= nextProps.itemSelected;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    rendererItem = (item, { handleClick, modifiers, query }) =>{
        const {id, fieldText, fieldLabel, fieldKey} = this.state;
        //console.log("renderItem: fieldKey ", fieldKey, " fieldLabel: ", fieldLabel);
        //console.log("item[fieldKey]: ", item[fieldKey]);
        if (item[fieldKey] != undefined) {
            return (
                <MenuItem
                    active={modifiers.active}
                    disabled={modifiers.disabled}
                    label={fieldLabel && item[fieldLabel] ? "(" + item[fieldLabel] + ") " : ""}
                    key={id + item[fieldKey]}
                    onClick={handleClick}
                    text={item[fieldText]}
                />
            );
        }
    };

    valueChanged = (item) => {
        //console.log("ComboBox - valueChanged");
        //console.log(item);
        const {onValueChanged} = this.props;
        this.setState({ itemSelected : item });
        onValueChanged && onValueChanged(item);
    }

    filter = (query, item) => {
        const {fieldText, fieldLabel} = this.state;
        if (item && item[fieldText] && item[fieldLabel])
            return item[fieldText].toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
                item[fieldLabel].toLowerCase().indexOf(query.toLowerCase()) >= 0
        else
            return true;
    };

    render() {
        const {className, id, items, itemSelected, fieldText, icon, filterable, placeholder, popoverClassName} = this.state;
        //console.log("ComboBox - Render");
        //console.log("items: ", items);

        return (
            <div>
            {   items && items.length > 0 &&
                <Select
                    className={className}
                    id={id}
                    itemPredicate={this.filter}
                    itemRenderer={this.rendererItem}
                    items={items}
                    onItemSelect={this.valueChanged}
                    filterable={filterable}
                    popoverProps={{popoverClassName: popoverClassName}}
                >
                    <Button
                        className={className}
                        alignText="left"
                        icon={icon ? icon : "group-objects"}
                        rightIcon="caret-down"
                        text={itemSelected ? itemSelected[fieldText] : placeholder}
                    />
                </Select>
            }
            </div>
        );
    }
}


ComboBox.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    fieldText: PropTypes.string,
    fieldLabel: PropTypes.string,
    fieldKey: PropTypes.string,
    items: PropTypes.array.isRequired,
    onValueChanged: PropTypes.func,
    placeholder: PropTypes.string,
    filterable: PropTypes.bool,
    itemSelected: PropTypes.object,
    popoverClassName: PropTypes.string,
    icon: PropTypes.string,
}

export default ComboBox;